import React, { useLayoutEffect, useRef, useState } from "react";

/**
 * Collapses tall block content to `max` px with a fade, revealing a
 * "show more" toggle only when the content actually overflows. The toggle
 * stops click propagation so it never triggers the card's deep-link.
 */
const Collapsible: React.FC<{ children: React.ReactNode; max?: number }> = ({ children, max = 76 }) => {
  const [expanded, setExpanded] = useState(false);
  const [overflowing, setOverflowing] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el) setOverflowing(el.scrollHeight > max + 8);
  }, [max]);

  const collapsed = !expanded && overflowing;
  return (
    <div className="collapsible">
      <div
        ref={ref}
        className={"collapsible-inner" + (collapsed ? " is-collapsed" : "")}
        style={collapsed ? { maxHeight: max } : undefined}
      >
        {children}
      </div>
      {overflowing && (
        <button
          type="button"
          className="show-more-btn"
          onClick={(ev) => { ev.stopPropagation(); setExpanded((v) => !v); }}
        >
          {expanded ? "show less ↑" : "show more ↓"}
        </button>
      )}
    </div>
  );
};

export default Collapsible;
